'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popover = require('material-ui/lib/popover/popover');

var _popover2 = _interopRequireDefault(_popover);

var _list = require('material-ui/lib/lists/list');

var _list2 = _interopRequireDefault(_list);

var _Subheader = require('material-ui/lib/Subheader');

var _Subheader2 = _interopRequireDefault(_Subheader);

var _listItem = require('material-ui/lib/lists/list-item');

var _listItem2 = _interopRequireDefault(_listItem);

var _dialog = require('material-ui/lib/dialog');

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryPopover = function (_Component) {
  _inherits(BinaryPopover, _Component);

  function BinaryPopover(props) {
    _classCallCheck(this, BinaryPopover);

    var _this = _possibleConstructorReturn(this, (BinaryPopover.__proto__ || Object.getPrototypeOf(BinaryPopover)).call(this, props));

    _this.state = {
      open: false,
      open_details: false,
      message_details: ''
    };
    _this.styles = require('./BinaryPopover.scss');
    return _this;
  }

  _createClass(BinaryPopover, [{
    key: 'getList',
    value: function getList() {
      var _this2 = this;

      var list = this.props.list;

      var LIST = [];
      var count = 1;
      list.forEach(function (item, index) {
        LIST.push(_react2.default.createElement(
          'div',
          { key: index, id: 'binary_popover_' + index },
          _react2.default.createElement(_listItem2.default, {
            className: count % 2 === 0 ? _this2.styles.binary_popover_item_even : _this2.styles.binary_popover_item,
            primaryText: item.primaryText,
            secondaryText: item.secondaryText,
            secondaryTextLines: 2,
            onClick: _this2.showDetails.bind(_this2, item)
          })
        ));
        count++;
      });
      return LIST;
    }
  }, {
    key: 'getNoData',
    value: function getNoData() {
      return _react2.default.createElement(
        'div',
        { id: 'binary_popover_none' },
        _react2.default.createElement(_listItem2.default, {
          className: this.styles.binary_popover_item,
          secondaryText: 'No Data Yet!',
          secondaryTextLines: 2
        })
      );
    }
  }, {
    key: 'showDetails',
    value: function showDetails(item) {
      if (item.detail !== null) {
        this.setState({
          open_details: true,
          message_details: item.detail
        });
      }
    }
  }, {
    key: 'handleOpenDetails',
    value: function handleOpenDetails() {
      this.setState({ open_details: true });
    }
  }, {
    key: 'handleCloseDetails',
    value: function handleCloseDetails() {
      this.setState({ open_details: false });
    }
  }, {
    key: 'handleTouchTap',
    value: function handleTouchTap(event) {
      this.setState({
        open: true,
        anchorEl: event.currentTarget
      });
    }
  }, {
    key: 'handleRequestClose',
    value: function handleRequestClose() {
      this.setState({
        open: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          title = _props.title,
          node = _props.node,
          icon = _props.icon,
          maxHeight = _props.maxHeight,
          closeOnClick = _props.closeOnClick;


      return _react2.default.createElement(
        'div',
        { className: this.styles.binary_popover },
        _react2.default.createElement(
          _dialog2.default,
          {
            style: { 'zIndex': 9999999 },
            title: '',
            modal: false,
            open: this.state.open_details,
            onRequestClose: this.handleCloseDetails.bind(this)
          },
          this.state.message_details
        ),
        (node || list) && _react2.default.createElement(
          'div',
          { onTouchTap: this.handleTouchTap.bind(this) },
          icon
        ),
        _react2.default.createElement(
          _popover2.default,
          {
            open: this.state.open,
            autoCloseWhenOffScreen: false,
            anchorEl: this.state.anchorEl,
            useLayerForClickAway: false,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            targetOrigin: { horizontal: 'left', vertical: 'top' },
            onRequestClose: this.handleRequestClose.bind(this),
            style: this.props.style ? this.props.style : { 'width': '500px', 'border': '1px solid #555' }
          },
          _react2.default.createElement(
            'div',
            { style: this.styles.binary_popover_container },
            _react2.default.createElement(
              _list2.default,
              null,
              _react2.default.createElement(
                _Subheader2.default,
                { onTouchTap: closeOnClick && this.handleRequestClose.bind(this), className: this.styles.binary_popover_header },
                title
              ),
              list && _react2.default.createElement(
                'div',
                { style: maxHeight ? { maxHeight: maxHeight } : {}, className: this.styles.binary_popover_content },
                list.length > 0 && this.getList(),
                list.length === 0 && this.getNoData()
              ),
              node && _react2.default.createElement(
                'div',
                { onTouchTap: closeOnClick && this.handleRequestClose.bind(this), className: this.styles.binary_popover_content },
                node
              )
            )
          )
        )
      );
    }
  }]);

  return BinaryPopover;
}(_react.Component);

BinaryPopover.propTypes = {
  icon: _propTypes2.default.node,
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  style: _propTypes2.default.object,
  maxHeight: _propTypes2.default.string,
  node: _propTypes2.default.node,
  list: _propTypes2.default.array, // { primaryText: ,secondaryText: , detail: }
  closeOnClick: _propTypes2.default.bool
};
BinaryPopover.defaultProps = {
  closeOnClick: false
};
exports.default = BinaryPopover;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryPopover/BinaryPopover.js
// module id = 2240
// module chunks = 1